import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import MESSAGES from 'core/data-model/constants/messages'
import { InsuredInformationBreadcrumb } from 'quick-quote/components'
import RiskProfile from 'quick-quote/product-investment/components/risk-profile'
import { FundCategories } from 'quick-quote/product-investment/fund-allocation/components/fund-categories'
import FundSummary from 'quick-quote/product-investment/fund-allocation/components/fund-summary/index'

const RiskProfileWrapper = styled.div`
  max-width: 680px;
  background: white;
  margin: 0 auto 20px auto;
`
const FundAllocationComponent = ({
  funds,
  allocations,
  totalAllocation,
  toggleFundAllocation,
  calculateTotalFundAllocation,
  resetFundAllocations,
  allowHigherRiskInvestment,
  allowForeignInvestment,
  isLowRiskEvaluated,
  hasValidEntryComponent,
  navTabList,
  rppAcceptFundAllocation,
  isAcceptOverRisk,
  isAcceptForeign,
  rppAcceptHigherRiskInvestment,
  rppAcceptForeignInvestment,
  foreignExchangingQuestion,
  resetRppAcceptFundAllocation,
}) => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [rppAcceptFundAllocation])
  const goToRPQAndRetest = () => {
    const RPQTab = navTabList.find((tab) => tab.id === 'invest')
    const history = useHistory()
    if (RPQTab) history.push(RPQTab.path)
  }
  return (
    <div id="fund-allocation" className="fund-allocation">
      <InsuredInformationBreadcrumb />
      <div className="content">
        {rppAcceptFundAllocation === true ? (
          <div>
            <FundSummary
              fundSummaryTitile={MESSAGES.RPP_SUMMARY_FUND_TITLE}
              allocations={allocations}
              isAcceptOverRisk={isAcceptOverRisk}
              isAcceptForeign={isAcceptForeign}
              rppAcceptHigherRiskInvestment={rppAcceptHigherRiskInvestment}
              rppAcceptForeignInvestment={rppAcceptForeignInvestment}
              resetRppAcceptFundAllocation={resetRppAcceptFundAllocation}
              foreignExchangingQuestion={foreignExchangingQuestion}
            />
          </div>
        ) : (
          <div>
            <RiskProfileWrapper>
              <RiskProfile onRetakeRPQConfirmed={goToRPQAndRetest} />
            </RiskProfileWrapper>
            <FundCategories
              allocations={allocations}
              funds={funds}
              totalAllocation={totalAllocation}
              resetFundAllocations={resetFundAllocations}
              toggleFundAllocation={toggleFundAllocation}
              calculateTotalFundAllocation={calculateTotalFundAllocation}
              allowHigherRiskInvestment={allowHigherRiskInvestment}
              allowForeignInvestment={allowForeignInvestment}
              isLowRiskEvaluated={isLowRiskEvaluated}
              hasValidEntryComponent={hasValidEntryComponent}
              elementIdToSnapAllocationBar={'fund-allocation'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

FundAllocationComponent.displayName = 'FundAllocation'

export const FundAllocation = FundAllocationComponent
